import { useQuery } from '@tanstack/react-query';

import { getDataTemp } from 'src/app/queries';

export const onlinePlatformTypesQueryKey = ['online-platform-types'];

type OnlinePlatformType = {
  Description: string;
  Id: number;
};

const GET_ONLINE_PLATFORM_TYPES = 'api/v2/discount/online-platform-types';

export function useOnlinePlatformTypesQuery() {
  return useQuery({
    queryKey: onlinePlatformTypesQueryKey,
    queryFn: () => getDataTemp<OnlinePlatformType[]>(GET_ONLINE_PLATFORM_TYPES),
  });
}
